import { RessourcesModelService } from '../../ressources/services/ressources-model.service';
import { RessourcesModel } from '../../ressources/models/ressources.model';
import { SitProModelAdapter } from './SitProModelAdapter';
import { SitProModel } from '../models/sitpro.model';
import { AffichageSitProModel } from '../models/affichage-sitpro.model';


/**
 * Objet qui contient les informations pour l'affichage des questions de la situation professionnelle
 */
export class AffichageSitProService {

  static SEUIL_TOTAL = 15000;

  /**
   * Construction de l'objet
   */
  constructor() {}

    /**
     * Détermine les questions à afficher.
     * 
     * Renvoie une map contenant uniquement les questions qui ont changé de statut d'affichage.
     * Cette map est utilisée pour vider les réponses, ajouter des validator etc dans le controleur.
     * On ne donne que les champs qui ont changé pour éviter de faire des passages inutiles dans le listener valueChange du formulaire (performance).
     * 
     * Les clées des maps correspondent au nom du formControl de chaque question.
     * 
     * @param ressources RessourcesModel
     * @param sitPro SitProModel
     */
  static determinerAffichage(ressources : RessourcesModel, sitPro : SitProModel) : AffichageSitProModel {

    const result = new AffichageSitProModel();
        
    const isQuestionSituation = this.affichageQuestionSituation(ressources);

    result.isQuestionSituation = isQuestionSituation;

    result.isQuestionProfessionnelle = this.affichageQuestionActivitePro(ressources, sitPro);
    
    result.isQuestionChomage = this.affichageQuestionChomage(sitPro);
    
    result.isQuestionIndemnise = this.affichageQuestionIndemnite(isQuestionSituation, sitPro, ressources);

    return result;
  }

  /**
   * Gestion de l'affichage de la question 1
   */
  static affichageQuestionSituation(ressources : RessourcesModel) : boolean {

    const montantTotal : number = RessourcesModelService.calculerTotal(ressources);

    const isAuMoinsUneRessDefinie : boolean = (
      ressources.salaireDefini ||
      ressources.chomagePreretraitreDefini ||
      ressources.pensionAlimentaireDefini ||
      ressources.retraitrePensionDefini ||
      ressources.revenuIndependentAnneeMoins2Defini
    );

    return (
      (montantTotal < AffichageSitProService.SEUIL_TOTAL && isAuMoinsUneRessDefinie) || 
      ressources.aucunRevenuDefini
    );
  }

  /**
   * Gestion de l'affichage de la question 2.
   * On determine l'affichage de cette question en foncfion des ressources 
   * et aussi en fonction de l'affichage de question précédente
   */
  static affichageQuestionActivitePro(ressources : RessourcesModel, sitPro : SitProModel) : boolean {

    const montantTotal = RessourcesModelService.calculerTotal(ressources);
    const sitProAdapter = new SitProModelAdapter(sitPro);

    return (
      ressources.chomagePreretraitreDefini &&
      (
        (
          montantTotal < AffichageSitProService.SEUIL_TOTAL && 
          sitProAdapter.isCodeSituationDefini() && 
          !sitProAdapter.isBeneficiaireRSA()
        ) ||
        (
          montantTotal >= AffichageSitProService.SEUIL_TOTAL
        )
      ) &&
      (
        ressources.salaireDefini ||
        ressources.revenuIndependentAnneeMoins2Defini
      )
    );
  }

  /**
   * Gestion de l'affichage de la question 2.1
   * La question est affichée en fonction du résultat de la question 2
   */
  static affichageQuestionChomage(sitPro : SitProModel) : boolean {
    const sitProAdapter = new SitProModelAdapter(sitPro);
    return (sitProAdapter.isEnActiviteDefini() && !sitProAdapter.isEnActivite());
  }

  /**
   * Gestion de l'affichage de la question 3
   * 
   * On determine l'affichage de cette question en foncfion des ressources, de la saisie de la sit pro
   * 
   */
  static affichageQuestionIndemnite(isQuestionSituation : boolean, sitPro : SitProModel, ressources : RessourcesModel) : boolean {
    const sitProAdapter = new SitProModelAdapter(sitPro);
    const isBenefRsa =  sitProAdapter.isBeneficiaireRSA();

    const isChomagePreRetraiteSeul = 
      ressources.chomagePreretraitreDefini &&
      !ressources.aucunRevenuDefini &&
      !ressources.salaireDefini &&
      !ressources.pensionAlimentaireDefini &&
      !ressources.retraitrePensionDefini &&
      !ressources.revenuIndependentAnneeMoins2Defini
    ;

    return (isChomagePreRetraiteSeul &&
            (
              (isQuestionSituation && sitProAdapter.isCodeSituationDefini() && !isBenefRsa) ||
              !isQuestionSituation
            )
    );
  }
}
